module.exports = __webpack_public_path__ + "static/media/c.1c1888a3.png";